<template>
    <section class="flexContainer contentBuilderModule">
        <section id="moduleDetailsSection">
            <div id="moduleInfo" v-if="item !== null">
                <h2 id="moduleName" class="uppercase h2Title">{{ item.terms.name.en.value }} / {{ item.terms.name.fr.value }}</h2>
                <h2 id="reference" class="uppercase h2Title">{{ diamRef1 }} / {{ clientRef1 }}</h2>
            </div>

            <div class="headerPanel"><p>Products on module</p></div>

            <div id="relImgContainer" class="fw-w">
                <div class="relatedProductImage" v-for="n in products" :key="n.id">
                    <div id="relatedImage" class="relatedImage rel fd-c jc-fs">
                        <img :src="getImgPath(n.figures.big, 'big')" width="200" class="block imagePrincipal" alt="" v-if="n.figures.big !== null" />
                        <h3 class="uppercase bold refRelated">
                            <span>{{ n.terms.name["en"]["value"] }} / {{ n.terms.name["fr"]["value"] }}</span>
                            <img src="../../assets/link_icon.svg" class="pointer" @click="link(n);" height="15" alt="" />
                        </h3>
                    </div>
                </div>
            </div>
            <CommentBloc :appId="2" :commentData="commentData"></CommentBloc>
        </section>
        <svg id="builderModule"></svg>
    </section>
</template>
<script>
import { utilsMixin } from "./mixins/utils";
import CommentBloc from "../CommentBloc/CommentBloc";

const d3 = require("d3");

import { stateMixin } from "./mixins/state";
import { componentMixin } from "./mixins/component";
import Globals from "./../globals";
import { mapGetters } from "vuex";
import cacheService from "@/services/cache";

export default {
    mixins: [stateMixin, componentMixin, utilsMixin],
    components: { CommentBloc },
    watch: {
        onAddComment(obj) {
            /* TODO Refacto avec method en state */
            let commentsStatus = this.getCommentsStatus;
            let commentIndex = commentsStatus.findIndex(commentStatus => commentStatus.UUID === obj.UUID);
            if (commentIndex === -1) {
                let objectToAdd = { UUID: obj.UUID, commentStatus: [], commentPrivate: [] };
                commentIndex = commentsStatus.push(objectToAdd) - 1;
            }
            if (obj.type === "PUBLIC") {
                commentsStatus[commentIndex].commentStatus = [{ user: obj.user, status: "seen" }];
            } else {
                let currentUser = cacheService.getRem3rchUser().user.id;
                if (!commentsStatus[commentIndex].commentPrivate.find(user => user === currentUser)) {
                    commentsStatus[commentIndex].commentPrivate.push(currentUser);
                }
            }
            let planoId = this.getPlanoDetails.id;
            this.saveCommentsStatus({ planoId, commentsStatus });
        },
        onRemoveComment(obj) {
            /* TODO Refacto avec method en state */
            let commentsStatus = this.getCommentsStatus;
            let commentIndex = commentsStatus.findIndex(commentStatus => commentStatus.UUID === obj.UUID);
            if (commentIndex === -1) {
                let objectToAdd = { UUID: obj.UUID, commentsStatus: [], commentPrivate: [] };
                commentIndex = commentsStatus.push(objectToAdd) - 1;
            }
            if (obj.type === "PRIVATE" && obj.left === 0) {
                let currentUser = cacheService.getRem3rchUser().user.id;
                let userStatusIndex = commentsStatus[commentIndex].commentPrivate.findIndex(user => user === currentUser);
                if (userStatusIndex !== -1) {
                    commentsStatus[commentIndex].commentPrivate.splice(userStatusIndex, 1);
                }
            }
            let planoId = this.getPlanoDetails.id;
            this.saveCommentsStatus({ planoId, commentsStatus });
        },

        getTicketStripClone(value) {
            let elt = value.elt;
            let bbElt = elt.getBoundingClientRect();
            let ticketStrip = null;
            this.getModulesEdit.forEach(mod => {
                if (ticketStrip === null) {
                    ticketStrip = mod.config.tickets.find(ticket => {
                        return ticket.id === value.id;
                    });
                }
            });
            // console.log(ticketStrip)
            if (!ticketStrip) return;
            let svgModule = d3.select(this.svg).select("svg");
            let ticketRect = svgModule.select("g#TICKET_STRIPS").select("rect#" + ticketStrip.idElt);
            let bbRect = ticketRect.node().getBoundingClientRect();
            // // this.get
            let clone = elt.cloneNode(true);
            clone.style.position = "absolute";
            clone.style.zIndex = 100;
            clone.style.width = bbRect.width + "px";
            clone.style.height = bbRect.height + "px";
            clone.style.top = bbElt.y + "px";
            clone.style.left = bbElt.x + "px";
            //
            document.querySelector("#builderWrapper").appendChild(clone);

            let drag = d3
                .drag()
                .on("start", this.dragStartTicket)
                .on("drag", this.dragTicket)
                .on("end", this.dragEndTicket);
            d3.select(clone).call(drag);

            let init = {
                bubbles: true,
                cancelable: true,
                view: window
            };
            let evt = new MouseEvent("mousedown", init);
            clone.dispatchEvent(evt);
        }
    },
    data() {
        return {
            products: [],
            moduleId: null,
            item: null,
            svg: null,
            content: null,
            heightModule: 0,
            configs: {},
            ticketStripToSave: {},
            commentData: {
                plano: null,
                component: null,
                componentIdExternal: null
            }
        };
    },
    created() {
        this.commentData.plano = { id: this.$route.params.id };
        this.commentData.component = { id: this.getModulesEdit[0].id };
        this.commentData.componentIdExternal = this.getModulesEdit[0].UUID;
    },
    mounted() {
        this.updateCommentsStatus();
        let modulesEdit = this.getModulesEdit;
        modulesEdit.sort((mod1, mod2) => {
            return mod1.posY - mod2.posY;
        });

        modulesEdit.sort((mod1, mod2) => {
            return mod1.posX - mod2.posX;
        });
        // console.log(modulesEdit, 'module')
        let positions = [];
        let posXMin = 0;
        let posYMin = 0;
        let position;
        modulesEdit.forEach((pos, i) => {
            if (i === 0) {
                posXMin = pos.posX;
                posYMin = pos.posY;
            } else {
                if (posXMin > pos.posX) posXMin = pos.posX;
                if (posYMin > pos.posY) posYMin = pos.posY;
            }
        });

        modulesEdit.forEach((pos, i) => {
            let x = pos.posX - posXMin;
            let y = pos.posY - posYMin;
            positions.push({
                posX: x,
                posY: y,
                size: pos.size
            });
        });

        if (modulesEdit.length > 0) {
            let moduleEdit = modulesEdit[0];
            this.getRelatedProductsAction({ id: moduleEdit.id }).then(products => {
                //                    console.log(products, 'products')
                this.products = products;
                this.setDisplayMenuShades(true);
            });
            let countTotal = modulesEdit.length;
            let countCurrent = 0;
            let svgBuilder = document.querySelector("#builderModule");
            this.svg = svgBuilder;
            this.content = d3
                .select(svgBuilder)
                .data([{ transform: null }])
                .append("g")
                .node();

            this.getDetails({ id: moduleEdit.id }).then(res => {
                this.item = res;

                modulesEdit.forEach((module, i) => {
                    let itemCopy = this.assign(res.config);
                    if (!itemCopy) {
                        console.error("La configuration est nulle");
                        return;
                    }

                    position = positions[i];
                    module.doLoadConfigModule = false;
                    let config = module.config;

                    if (config) {
                        if (!config.groups) {
                            module.doLoadConfigModule = true;
                            config.groups = itemCopy.groups;
                        }
                    } else {
                        module.doLoadConfigModule = true;
                        config = itemCopy;
                    }

                    module.config = config;
                    this.loadModule(module, position)
                        .then(() => {
                            countCurrent++;
                            return countCurrent;
                        })
                        .then(count => {
                            if (countTotal === count) {
                                // let transform2 = d3.zoomTransform(this.content)
                                //                                console.log(transform, 'trans ====')

                                let bb = this.content.getBBox();
                                let bbSvg = this.svg.getBoundingClientRect();
                                //                                console.log(bb, bbSvg)
                                let height = bb.height > bbSvg.height ? bb.height + 500 : bb.height;
                                let width = bb.width > bbSvg.width ? bb.width + 400 : bb.width;

                                d3.select(this.svg).attr("viewBox", "0 0 " + width + " " + height);
                                d3.select(this.svg).call(
                                    d3
                                        .zoom()
                                        .scaleExtent([0.5, 20])
                                        .on("zoom", data => {
                                            let transform = d3.event.transform;
                                            //                    console.log(transform)
                                            data.transform = transform;
                                            d3.select(this.content).attr("transform", transform);
                                        })
                                );
                            }
                        });
                });
            });
        }
    },
    beforeDestroy() {
        let self = this;
        this.setDisplayMenuShades(false);
        if (this.canModeSave) {
            Object.values(this.ticketStripToSave).forEach(confTicketToSave => {
                // console.log(confTicketToSave, '=========================')
                confTicketToSave.confTicket.ticket = confTicketToSave.ticketUpdate;
            });
            let svgs = d3.select(this.svg).selectAll("svg");
            this.setUpdatePlano(false);
            svgs.each((data, i, cmps) => {
                let svg = cmps[i];
                let pathG = d3
                    .select(svg)
                    .select("g#FILL")
                    .selectAll("g")
                    .filter(function() {
                        return self._.startsWith(d3.select(this).attr("id"), "row");
                    });

                let moduleEdit = this.configs[svg.id];
                let configMod = moduleEdit.config;
                let row;
                let groups = configMod.groups;
                let config;
                pathG.each((d, i, cmps2) => {
                    row = cmps2[i];
                    config = groups.find(conf => {
                        return conf.rowId === row.id;
                    });
                    if (d === undefined) {
                        if (config.color === undefined) config.color = null;
                    } else {
                        config.color = d;
                    }
                });

                moduleEdit.config = configMod;
                let module = document.querySelector("#" + moduleEdit.UUID);
                if (moduleEdit.doLoadConfigModule) {
                    this.loadConfigModule(module, moduleEdit);
                } else {
                    // console.log('=====')
                    this.loadCommentBadge(module, this.getCommentsStatus, moduleEdit);
                    this.loadColor(module, moduleEdit);
                    this.loadTicketStrips(module, moduleEdit);
                }
            });
        }
    },
    computed: {
        ...mapGetters("events/comments", {
            onAddComment: "onAddComment",
            onRemoveComment: "onRemoveComment"
        }),
        diamRef1() {
            return this.item.infosArticle.diam_ref1 ? this.item.infosArticle.diam_ref1.componentProperty.value : "";
        },
        clientRef1() {
            return this.item.infosArticle.client_ref1 ? this.item.infosArticle.client_ref1.componentProperty.value : "";
        }
    },
    methods: {
        closeCommentsModal() {
            this.showComments = false;
        },
        openCommentsModal() {
            this.showComments = true;
        },
        dragStartTicket(d, i, cmps) {},
        dragTicket(d, i, cmps) {
            let event = d3.event;
            let cmp = cmps[i];
            let bb = cmp.getBoundingClientRect();
            cmp.style.left = event.x - bb.width / 3 + "px";
            cmp.style.top = event.y - bb.height / 2 + "px";
        },
        dragEndTicket(d, i, cmps) {
            // console.log(this.getTicketStripClone, '=======')
            let img = cmps[i];
            let event = d3.event;
            let svg = this.elementFromPoint("svg#builderModule svg", event.sourceEvent.pageX, event.sourceEvent.pageY);
            let elt = this.elementFromPoint("svg#builderModule svg g#TICKET_STRIPS rect", event.sourceEvent.pageX, event.sourceEvent.pageY);
            if (elt !== null) {
                let idSeach = svg.id.replace("config_", "");

                let moduleData = this.getModulesEdit.find(mod => {
                    return mod.UUID === idSeach;
                });

                let ticketStriptModule = moduleData.config.tickets.find(ticket => {
                    return ticket.idElt === elt.id;
                });

                if (this.checkAddTicketStrip(ticketStriptModule.tickets)) {
                    let confTicket = this.configs[svg.id].config.tickets.find(tic => {
                        return tic.idElt === elt.id;
                    });
                    //
                    this.ticketStripToSave[idSeach + elt.id] = {
                        confTicket: confTicket,
                        ticketUpdate: this.createDataTicketStrip(this.getTicketStripClone.data, elt.getBBox())
                    };

                    this.createTicketStrip(elt, img.src);
                } else {
                    this.$swal({
                        title: "",
                        text: this.$t("planobuilder.messageAlert1"),
                        type: "warning",
                        confirmButtonText: "OK"
                    });
                }
            }

            img.parentNode.removeChild(img);
            // elt.append()
        },
        checkAddTicketStrip(tickets) {
            let check = tickets.length > 1;

            if (check) {
                let id = this.getTicketStripClone.data.id;
                let ticket = tickets.find(t => {
                    return t.id === id;
                });
                check = ticket !== undefined;
            }
            return check;
        },
        calculRatio(width, height, widthSvg, heightSvg) {
            let heightChild = parseInt(height, 10);
            let widthChild = parseInt(width, 10);

            let ratioH = heightSvg / heightChild;
            let ratioW = widthSvg / widthChild;
            let ratio = 0;
            if (widthChild === heightChild) {
                if (ratioH < ratioW) {
                    ratio = ratioH;
                } else {
                    ratio = ratioW;
                }
            } else if (widthChild < heightChild) {
                ratio = ratioH;
            } else {
                ratio = ratioW;
            }
            return ratio;
        },
        loadModule(module, position) {
            let svgUrls = this._.find(this.item.figures_advanced, o => {
                return o.id_type_file === 6;
            });
            let url = Globals.getBaseUrl() + svgUrls.big;
            return this.eltSvg(url)
                .then(elt => {
                    let uuid = "config_" + module.UUID;
                    elt.id = uuid;
                    this.configs[uuid] = module;
                    let names = ["MODULES"];
                    names.forEach(name => {
                        d3.select(elt)
                            .selectAll("g#" + name)
                            .attr("id", "MODULE");
                        d3.select(elt)
                            .selectAll("g#" + name.toLowerCase())
                            .attr("id", "MODULE");
                    });

                    let g = d3
                        .select(elt)
                        .select("g#MODULE")
                        .node();
                    this.content.appendChild(elt);
                    let bb = g.getBBox();
                    let height = bb.height * module.size.height;
                    let width = bb.width * module.size.width;
                    let moduleD3 = d3.select(elt);
                    moduleD3.attr("height", height);
                    moduleD3.attr("width", width);
                    moduleD3.attr("x", () => {
                        return position.posX * bb.width;
                    });
                    moduleD3.attr("y", () => {
                        return position.posY * bb.height;
                    });
                    return elt;
                })
                .then(moduleElt => {
                    this.loadConfigModule(moduleElt, module, true);
                    this.addListeners();
                    return moduleElt;
                });
        },
        getImgPath(imgPath, format) {
            return Globals.getBaseUrl() + imgPath;
        },
        link(item) {
            window.open("/" + item.type + "/" + item.id);
        },
        updateCommentsStatus() {
            let commentsStatus = this.getCommentsStatus;
            let commentIndex = commentsStatus.findIndex(commentStatus => commentStatus.UUID === this.getModulesEdit[0].UUID);
            if (commentIndex === -1) {
                return;
            }
            let currentUser = cacheService.getRem3rchUser().user.id;
            let userStatus = commentsStatus[commentIndex].commentStatus.findIndex(statusObject => statusObject.user === currentUser);
            if (userStatus === -1) {
                commentsStatus[commentIndex].commentStatus.push({ user: currentUser, status: "seen" });
                let planoId = this.getPlanoDetails.id;
                this.saveCommentsStatus({ planoId, commentsStatus });
            }
        },
        addListeners() {
            let self = this;
            let pathG = d3
                .select(this.svg)
                .selectAll("svg")
                .selectAll("g")
                .filter(function() {
                    return self._.startsWith(d3.select(this).attr("id"), "row");
                });
            pathG.selectAll("path").select(function() {
                d3.select(this).on("click", function() {
                    let selectedShade = d3.select("#shadesWrapper").select("p.selected");
                    if (selectedShade.node() !== null) {
                        let shadeData = selectedShade.data()[0];
                        d3.selectAll(this.parentNode.children)
                            .filter(function(d) {
                                return d3.select(this).property("tagName") === "path";
                            })
                            .each(function() {
                                self.pathColor(shadeData, this, d3.select(this.parentNode), true);
                            });
                    }
                });
            });
        }
    }
};
</script>
<style lang="scss">
.h2Title {
    margin: 10px 0px;
}

.headerPanel {
    background-color: #777777;
    color: #ffffff;
    text-transform: uppercase;
    font-size: 20px;
    padding: 8px 10px;
    p {
        margin: 0px;
    }
}

.return {
    padding-right: 10px;
    padding-bottom: 3px;
}

#builderModule {
    width: calc(100% - 750px);
    height: 100%;
    text,
    & tspan {
        width: 100% !important;
        font-family: "Oswald", sans-serif !important;
        /*font-size: 30px !important;*/
        text-transform: uppercase;
    }
    .textDIAM,
    .textclient {
        /*font-size: 22px !important;*/
    }
}

.contentBuilderModule {
    height: 100%;
}

#moduleDetailsSection {
    width: 400px;
    margin-left: 60px;
    #relImgContainer {
        background: #fff;
        max-height: calc(100vh - 230px);
        height: 265px;
        overflow-y: auto;
        margin-bottom: 10px;

        .relatedProductImage {
            display: inline-block;
            vertical-align: top;
            width: 48%;
            margin: 0px 3px;

            .relatedImage {
                > img {
                    width: 70%;
                }
            }
            .refRelated span {
                line-height: 15px;
                font-size: 13px;
            }
        }
    }
}

.relatedImg {
    margin-top: 20px;
}

.cancelBtn {
    top: -102px;
    color: white;
    border: 1px solid white;
}

.closeConfModule {
    color: white;
    border: 1px solid white;
    right: 102px;
    top: -102px;
}

.imagePrincipal {
    width: 100%;
}
.badgeColorHighlight {
    display: inline-block;
    vertical-align: middle;
    height: 10px;
    width: 17px;
    margin: 0px 4px;
    border: 1px #444 solid;
}
</style>



// WEBPACK FOOTER //
// GroupEditor.vue?01987e61